// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-active-survey {
  width: 900px;
  height: 500px; /* Increased height to accommodate a larger bottom section */
  border: 1px solid #ccc;
  padding: 20px;
  box-shadow: 3px 5px 5px rgba(255, 255, 255, 0.4);
  display: flex;
  flex-direction: column;
  cursor: pointer;
  background-color:white;
  border-radius: 10px;
}

.home-active-survey__top {
  display: flex;
  justify-content: space-between;
  width: 100%;
  flex: 1.5 1;  /* Allocate 1.5x space to the top */
}

.home-active-survey__top-left {
  flex: 1 1;
  padding-right: 10px;
}

.home-active-survey__top-right {
  flex: 1 1;
  padding-left: 10px;
}

.chart-container {
  width: 100%;
  height: 200px;
}

.home-active-survey__bottom {
  margin-top: 0px;
  width: 100%;
  flex: 1 1;  /* Allocate 1x space to the bottom */
  overflow-y: auto;
}

.answers-table {
  display: flex;
  flex-direction: column;
}

.answers-table__header,
.answers-table__row {
  display: flex;
  border-bottom: 1px solid #ccc;
}

.answers-table__header {
  font-weight: bold;
  background-color: #f1f1f1;
}

.answers-table__header-item,
.answers-table__item {
  flex: 1 1;
  padding: 5px 10px;
}

.answers-table__item--question {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}

.answers-table__item--question:hover {
  overflow: visible;
  white-space: normal;
  position: relative;
  z-index: 1;
  background-color: #fff;
  border: 1px solid #ccc;
  padding: 5px;
}
.answers-table__header-item--datetime,
.answers-table__item--datetime {
  width: 150px; /* Pas de breedte aan naar wens */
  min-width: 150px; /* Optioneel, zorgt ervoor dat de kolom niet kleiner wordt */
  max-width: 150px; /* Optioneel, zorgt ervoor dat de kolom niet groter wordt */
  text-align: center; /* Optioneel, uitlijning van de tekst in het midden */
}
.answers-table__header-item--datetime,
.answers-table__item--datetime {
  width: 150px; /* Maak de kolom voor tijdstip smaller */
  min-width: 150px;
  max-width: 150px;
  text-align: center;
}

.answers-table__header-item--answer,
.answers-table__item--answer {
  width: 200px; /* Maak de kolom voor antwoord smaller */
  max-width: 200px;
  white-space: nowrap; /* Voorkom dat tekst naar een nieuwe regel wordt verplaatst */
  overflow: hidden; /* Verberg alles dat buiten de kolom past */
  text-overflow: ellipsis; /* Voeg "..." toe aan het einde van de afgekapt tekst */
}

.answers-table__item--answer:hover {
  overflow: visible; /* Zorg ervoor dat het hele antwoord zichtbaar is op hover */
  white-space: normal; /* Laat de tekst op meerdere regels verschijnen */
  background-color: #f5f5f5; /* Optioneel: pas de achtergrondkleur aan bij hover voor betere zichtbaarheid */
  position: relative; /* Zorg ervoor dat de hover-effecten goed werken */
  z-index: 1; /* Plaats de hover-effecten boven andere elementen */
}

.progress-bar {
  margin: 0;
  text-align: center;
}

.progress-bar__background {
  background-color: #D3D3D3;
  border-radius: 10px;
  overflow: hidden;
  height: 20px;
  width: 100%;
}

.progress-bar__progress {
  background-color: #4CAF50;
  height: 100%;
}

.progress-bar__labels {
  display: flex;
  justify-content: space-between;
  margin-top: 5px;
  font-size: 14px;
  color: #333;
}`, "",{"version":3,"sources":["webpack://./src/components/home/ActiveSurvey.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa,EAAE,4DAA4D;EAC3E,sBAAsB;EACtB,aAAa;EACb,gDAAgD;EAChD,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,WAAS,GAAG,mCAAmC;AACjD;;AAEA;EACE,SAAO;EACP,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAO,GAAG,oCAAoC;EAC9C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;;EAEE,SAAO;EACP,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,sBAAsB;EACtB,sBAAsB;EACtB,YAAY;AACd;AACA;;EAEE,YAAY,EAAE,iCAAiC;EAC/C,gBAAgB,EAAE,4DAA4D;EAC9E,gBAAgB,EAAE,2DAA2D;EAC7E,kBAAkB,EAAE,qDAAqD;AAC3E;AACA;;EAEE,YAAY,EAAE,wCAAwC;EACtD,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,YAAY,EAAE,wCAAwC;EACtD,gBAAgB;EAChB,mBAAmB,EAAE,6DAA6D;EAClF,gBAAgB,EAAE,2CAA2C;EAC7D,uBAAuB,EAAE,uDAAuD;AAClF;;AAEA;EACE,iBAAiB,EAAE,4DAA4D;EAC/E,mBAAmB,EAAE,iDAAiD;EACtE,yBAAyB,EAAE,+EAA+E;EAC1G,kBAAkB,EAAE,kDAAkD;EACtE,UAAU,EAAE,oDAAoD;AAClE;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,eAAe;EACf,WAAW;AACb","sourcesContent":[".home-active-survey {\n  width: 900px;\n  height: 500px; /* Increased height to accommodate a larger bottom section */\n  border: 1px solid #ccc;\n  padding: 20px;\n  box-shadow: 3px 5px 5px rgba(255, 255, 255, 0.4);\n  display: flex;\n  flex-direction: column;\n  cursor: pointer;\n  background-color:white;\n  border-radius: 10px;\n}\n\n.home-active-survey__top {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  flex: 1.5;  /* Allocate 1.5x space to the top */\n}\n\n.home-active-survey__top-left {\n  flex: 1;\n  padding-right: 10px;\n}\n\n.home-active-survey__top-right {\n  flex: 1;\n  padding-left: 10px;\n}\n\n.chart-container {\n  width: 100%;\n  height: 200px;\n}\n\n.home-active-survey__bottom {\n  margin-top: 0px;\n  width: 100%;\n  flex: 1;  /* Allocate 1x space to the bottom */\n  overflow-y: auto;\n}\n\n.answers-table {\n  display: flex;\n  flex-direction: column;\n}\n\n.answers-table__header,\n.answers-table__row {\n  display: flex;\n  border-bottom: 1px solid #ccc;\n}\n\n.answers-table__header {\n  font-weight: bold;\n  background-color: #f1f1f1;\n}\n\n.answers-table__header-item,\n.answers-table__item {\n  flex: 1;\n  padding: 5px 10px;\n}\n\n.answers-table__item--question {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  cursor: pointer;\n}\n\n.answers-table__item--question:hover {\n  overflow: visible;\n  white-space: normal;\n  position: relative;\n  z-index: 1;\n  background-color: #fff;\n  border: 1px solid #ccc;\n  padding: 5px;\n}\n.answers-table__header-item--datetime,\n.answers-table__item--datetime {\n  width: 150px; /* Pas de breedte aan naar wens */\n  min-width: 150px; /* Optioneel, zorgt ervoor dat de kolom niet kleiner wordt */\n  max-width: 150px; /* Optioneel, zorgt ervoor dat de kolom niet groter wordt */\n  text-align: center; /* Optioneel, uitlijning van de tekst in het midden */\n}\n.answers-table__header-item--datetime,\n.answers-table__item--datetime {\n  width: 150px; /* Maak de kolom voor tijdstip smaller */\n  min-width: 150px;\n  max-width: 150px;\n  text-align: center;\n}\n\n.answers-table__header-item--answer,\n.answers-table__item--answer {\n  width: 200px; /* Maak de kolom voor antwoord smaller */\n  max-width: 200px;\n  white-space: nowrap; /* Voorkom dat tekst naar een nieuwe regel wordt verplaatst */\n  overflow: hidden; /* Verberg alles dat buiten de kolom past */\n  text-overflow: ellipsis; /* Voeg \"...\" toe aan het einde van de afgekapt tekst */\n}\n\n.answers-table__item--answer:hover {\n  overflow: visible; /* Zorg ervoor dat het hele antwoord zichtbaar is op hover */\n  white-space: normal; /* Laat de tekst op meerdere regels verschijnen */\n  background-color: #f5f5f5; /* Optioneel: pas de achtergrondkleur aan bij hover voor betere zichtbaarheid */\n  position: relative; /* Zorg ervoor dat de hover-effecten goed werken */\n  z-index: 1; /* Plaats de hover-effecten boven andere elementen */\n}\n\n.progress-bar {\n  margin: 0;\n  text-align: center;\n}\n\n.progress-bar__background {\n  background-color: #D3D3D3;\n  border-radius: 10px;\n  overflow: hidden;\n  height: 20px;\n  width: 100%;\n}\n\n.progress-bar__progress {\n  background-color: #4CAF50;\n  height: 100%;\n}\n\n.progress-bar__labels {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 5px;\n  font-size: 14px;\n  color: #333;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
